import React from 'react';
import PropTypes from 'prop-types';

// 科目タブコンポーネント
const SubjectTabs = ({ subjects, selectedSubject, onSelectSubject }) => (
  <div className="mb-6">
    {/* 科目ボタンの表示（区切りなし） */}
    <div className="flex items-center space-x-2">
      {subjects.map(subject => (
        <button
          key={subject.id}
          onClick={() => onSelectSubject(subject)}
          className={`px-4 py-2 rounded-full font-medium transition-colors duration-200 ${
            selectedSubject.id === subject.id
              ? 'bg-purple-300 text-purple-800 shadow'
              : 'bg-purple-100 text-purple-700 hover:bg-purple-200'
          }`}
          aria-label={`科目タブ: ${subject.name}`}
        >
          {subject.name}
        </button>
      ))}
    </div>
  </div>
);

SubjectTabs.propTypes = {
  subjects: PropTypes.array.isRequired,
  selectedSubject: PropTypes.object.isRequired,
  onSelectSubject: PropTypes.func.isRequired,
};

export default SubjectTabs; 